import React from 'react'
import './index.sass'

function Notifiers({ icon, content, id, onCloseClick }) {

    const handleCloseNotifier = () => {
        onCloseClick(id)
    }
    
    return (
        <div id={id} className="feed-action-notifiers">
            <div className='fan-col-1'>
            <img  src={require(`../../assets/icons/${icon}`)} />
            <div className='fan-col-2'>
                {content}
            </div>
            </div>
            <div className='fan-col-3'>
                <img onClick={handleCloseNotifier}  src={require('../../assets/icons/notifcross.svg')} />
            </div>
        </div>
    )
}

export default React.memo(Notifiers)
